export class CustomerRequests {
  ChangeRequestID: number;
  Title: string;
  Description: string;
  RequestTypeID: number;
  CustomerID: number;
  Name: string;
  S_W_DoFTitle: string;
  S_W_DoF: string;
  Nationality: string;
  PassportNumber: string;
  AadhaarNumber: string;
  IDProofDocName: string;
  AddressProofDocName: string;
  IdProof: string;
  AddressProof: string;
  AddressProofFile: File;
  IdProofFile: File;
  IsRequestResolved: boolean;
  ChangeRequestType: string;
  Address: string;
  City: string;
  State: string;
  Pincode: string;
  CountryID: number;
  PhotoName: string;
  PhotoPath: string;
  PhotoFile: File;
  ////
  order_id: string;

  MobileNo: string;
  EmailId: string;
  Message: string;
  Status: boolean;
  CreatedOn: Date;
  RequestStatus : number;
  Reason : string;
  UpdatedOn : Date;
  CommunicationDocumentType: number;
  CommunicationDocumentName: string;
  CommunicationDocumentPath: string;
  IsIdProofRejected: boolean;
  IsAddressProofRejected: boolean;
  IsPhotoRejected: boolean;
  IsCommunicationDocumentRejected: boolean;
  IdProofRejectedReason: string;
  AddressProofRejectedReason: string;
  PhotoRejectedReason: string;
  CommunicationDocumentRejectedReason: string;
  CommunicationDocumentFile: File;
  PrimaryAadharNumber: string;
  JointNationality: string;
  PrimaryNationality: string;
  DocumentTypeName: string;
  CommunicationAddress: string;
  CommunicationCity: string;
  CommunicationState: string;
  CommunicationPincode: string;
  CommunicationCountryID: number;
  IsCommunicationAddressSameAsPremanent: boolean;
  JointAadharNumber: string;
  PrimaryPassportNumber: string;
  JointPassportNumber: string;
  PrimaryName: string;
  JointName: string;
  CanCancelRequest: boolean;
  PassportType:string;
}

export class CancelRequest{
  public ChangeRequestID: number;
}
